import type { BonusAccountResponse, BonusAccountShortResponse } from '@/core/generated/api';
import type { DataTableFilterMeta } from 'primereact/datatable';
import type { RequestStatus } from '@/shared/model/requestStatus';

/** Тип операции над бонусным балансом */
export enum BonusOperationKind {
    Accrue = 'accrue',
    Spend = 'spend',
}

/** Условия выдачи страницы бонусных счетов */
export interface BonusAccountListParams {
    filters: DataTableFilterMeta;
    take?: number;
    skip?: number;
    sortField?: string;
    sortOrder?: number;
}

/** Данные бонусных счетов */
export interface BonusAccountData {
    accounts: BonusAccountShortResponse[];
    currentAccount: BonusAccountResponse | null;
    allCount: number;
    filters: DataTableFilterMeta;
    listStatus: RequestStatus;
    detailsStatus: RequestStatus;
    listError: string | null;
    detailsError: string | null;
}

/** Действия бонусных счетов */
export interface BonusAccountActions {
    /** Сохраняет фильтры таблицы */
    setFilters: (filters: DataTableFilterMeta) => void;

    /** Загружает страницу бонусных счетов */
    fetchAccounts: (params: BonusAccountListParams) => Promise<void>;

    /** Загружает бонусный счёт клиента */
    fetchAccountByClientId: (clientId: string) => Promise<void>;

    /** Очищает выбранный счёт */
    clearCurrentAccount: () => void;

    /** Возвращает данные бонусных счетов в начальное состояние */
    reset: () => void;
}

/** Состояние бонусных счетов */
export type BonusAccountState = BonusAccountData & BonusAccountActions;
